// Action Types
const GET_ABOUT_US_PAGE_START = 'GET_ABOUT_US_PAGE_START';
const GET_ABOUT_US_PAGE_SUCCESS = 'GET_ABOUT_US_PAGE_SUCCESS';
const GET_ABOUT_US_PAGE_FAILED = 'GET_ABOUT_US_PAGE_FAILED';
const GET_ABOUT_US_PAGE_RESET = 'GET_ABOUT_US_PAGE_RESET';

const UPDATE_ABOUT_US_PAGE_START = 'UPDATE_ABOUT_US_PAGE_START';
const UPDATE_ABOUT_US_PAGE_SUCCESS = 'UPDATE_ABOUT_US_PAGE_SUCCESS';
const UPDATE_ABOUT_US_PAGE_FAILED = 'UPDATE_ABOUT_US_PAGE_FAILED';
const UPDATE_ABOUT_US_PAGE_RESET = 'UPDATE_ABOUT_US_PAGE_RESET';

const GET_PARTNER_LOGOS_START = 'GET_PARTNER_LOGOS_START';
const GET_PARTNER_LOGOS_SUCCESS = 'GET_PARTNER_LOGOS_SUCCESS';
const GET_PARTNER_LOGOS_FAILED = 'GET_PARTNER_LOGOS_FAILED';
const GET_PARTNER_LOGOS_RESET = 'GET_PARTNER_LOGOS_RESET';

const GET_ONE_PARTNER_LOGO_START = 'GET_ONE_PARTNER_LOGO_START';
const GET_ONE_PARTNER_LOGO_SUCCESS = 'GET_ONE_PARTNER_LOGO_SUCCESS';
const GET_ONE_PARTNER_LOGO_FAILED = 'GET_ONE_PARTNER_LOGO_FAILED';
const GET_ONE_PARTNER_LOGO_RESET = 'GET_ONE_PARTNER_LOGO_RESET';

const CREATE_PARTNER_LOGO_START = 'CREATE_PARTNER_LOGO_START';
const CREATE_PARTNER_LOGO_SUCCESS = 'CREATE_PARTNER_LOGO_SUCCESS';
const CREATE_PARTNER_LOGO_FAILED = 'CREATE_PARTNER_LOGO_FAILED';
const CREATE_PARTNER_LOGO_RESET = 'CREATE_PARTNER_LOGO_RESET';

const UPDATE_PARTNER_LOGO_START = 'UPDATE_PARTNER_LOGO_START';
const UPDATE_PARTNER_LOGO_SUCCESS = 'UPDATE_PARTNER_LOGO_SUCCESS';
const UPDATE_PARTNER_LOGO_FAILED = 'UPDATE_PARTNER_LOGO_FAILED';
const UPDATE_PARTNER_LOGO_RESET = 'UPDATE_PARTNER_LOGO_RESET';

const DELETE_PARTNER_LOGO_START = 'DELETE_PARTNER_LOGO_START';
const DELETE_PARTNER_LOGO_SUCCESS = 'DELETE_PARTNER_LOGO_SUCCESS';
const DELETE_PARTNER_LOGO_FAILED = 'DELETE_PARTNER_LOGO_FAILED';
const DELETE_PARTNER_LOGO_RESET = 'DELETE_PARTNER_LOGO_RESET';

// Initial State
const initialState = {
  // About Us Page
  getAboutUsPage: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  updateAboutUsPage: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  // Partner Logos
  getPartnerLogos: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  getOnePartnerLogo: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  createPartnerLogo: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  updatePartnerLogo: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
  deletePartnerLogo: {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  },
};

// Reducer
const aboutUsReducer = (state = initialState, action) => {
  switch (action.type) {
    // About Us Page
    case GET_ABOUT_US_PAGE_START:
      return {
        ...state,
        getAboutUsPage: action.payload,
      };
    case GET_ABOUT_US_PAGE_SUCCESS:
      return {
        ...state,
        getAboutUsPage: action.payload,
      };
    case GET_ABOUT_US_PAGE_FAILED:
      return {
        ...state,
        getAboutUsPage: action.payload,
      };
    case GET_ABOUT_US_PAGE_RESET:
      return {
        ...state,
        getAboutUsPage: initialState.getAboutUsPage,
      };

    case UPDATE_ABOUT_US_PAGE_START:
      return {
        ...state,
        updateAboutUsPage: action.payload,
      };
    case UPDATE_ABOUT_US_PAGE_SUCCESS:
      return {
        ...state,
        updateAboutUsPage: action.payload,
      };
    case UPDATE_ABOUT_US_PAGE_FAILED:
      return {
        ...state,
        updateAboutUsPage: action.payload,
      };
    case UPDATE_ABOUT_US_PAGE_RESET:
      return {
        ...state,
        updateAboutUsPage: initialState.updateAboutUsPage,
      };

    // Partner Logos
    case GET_PARTNER_LOGOS_START:
      return {
        ...state,
        getPartnerLogos: action.payload,
      };
    case GET_PARTNER_LOGOS_SUCCESS:
      return {
        ...state,
        getPartnerLogos: action.payload,
      };
    case GET_PARTNER_LOGOS_FAILED:
      return {
        ...state,
        getPartnerLogos: action.payload,
      };
    case GET_PARTNER_LOGOS_RESET:
      return {
        ...state,
        getPartnerLogos: initialState.getPartnerLogos,
      };

    case GET_ONE_PARTNER_LOGO_START:
      return {
        ...state,
        getOnePartnerLogo: action.payload,
      };
    case GET_ONE_PARTNER_LOGO_SUCCESS:
      return {
        ...state,
        getOnePartnerLogo: action.payload,
      };
    case GET_ONE_PARTNER_LOGO_FAILED:
      return {
        ...state,
        getOnePartnerLogo: action.payload,
      };
    case GET_ONE_PARTNER_LOGO_RESET:
      return {
        ...state,
        getOnePartnerLogo: initialState.getOnePartnerLogo,
      };

    case CREATE_PARTNER_LOGO_START:
      return {
        ...state,
        createPartnerLogo: action.payload,
      };
    case CREATE_PARTNER_LOGO_SUCCESS:
      return {
        ...state,
        createPartnerLogo: action.payload,
      };
    case CREATE_PARTNER_LOGO_FAILED:
      return {
        ...state,
        createPartnerLogo: action.payload,
      };
    case CREATE_PARTNER_LOGO_RESET:
      return {
        ...state,
        createPartnerLogo: initialState.createPartnerLogo,
      };

    case UPDATE_PARTNER_LOGO_START:
      return {
        ...state,
        updatePartnerLogo: action.payload,
      };
    case UPDATE_PARTNER_LOGO_SUCCESS:
      return {
        ...state,
        updatePartnerLogo: action.payload,
      };
    case UPDATE_PARTNER_LOGO_FAILED:
      return {
        ...state,
        updatePartnerLogo: action.payload,
      };
    case UPDATE_PARTNER_LOGO_RESET:
      return {
        ...state,
        updatePartnerLogo: initialState.updatePartnerLogo,
      };

    case DELETE_PARTNER_LOGO_START:
      return {
        ...state,
        deletePartnerLogo: action.payload,
      };
    case DELETE_PARTNER_LOGO_SUCCESS:
      return {
        ...state,
        deletePartnerLogo: action.payload,
      };
    case DELETE_PARTNER_LOGO_FAILED:
      return {
        ...state,
        deletePartnerLogo: action.payload,
      };
    case DELETE_PARTNER_LOGO_RESET:
      return {
        ...state,
        deletePartnerLogo: initialState.deletePartnerLogo,
      };

    default:
      return state;
  }
};

export default aboutUsReducer;
